import { render, staticRenderFns } from "./Supers.vue?vue&type=template&id=0a82669a&scoped=true&"
import script from "./Supers.vue?vue&type=script&lang=js&"
export * from "./Supers.vue?vue&type=script&lang=js&"
import style0 from "./Supers.vue?vue&type=style&index=0&id=0a82669a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a82669a",
  null
  
)

export default component.exports